import { render } from "./NewFront.vue?vue&type=template&id=3fa616c3&scoped=true"
import script from "./NewFront.vue?vue&type=script&lang=js"
export * from "./NewFront.vue?vue&type=script&lang=js"

import "./NewFront.vue?vue&type=style&index=0&id=3fa616c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa616c3"]])

export default __exports__